import { render, staticRenderFns } from "./ReadNextDefaultPost.vue?vue&type=template&id=458f2ec5"
import script from "./ReadNextDefaultPost.vue?vue&type=script&lang=js"
export * from "./ReadNextDefaultPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports